import * as actionTypes from "./ProductionGroupingTypes";

const INITIAL_STATE = {
    teamList: [],
    projectAssignmentList: [],
};

const ProductionGroupingReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SET_PRODUCTION_GROUPING_TEAM_LIST:
            return {
                ...state,
                teamList: action.payload.list,
            };
        case actionTypes.SET_PROJECT_ASSIGNMENT_LIST:
            return {
                ...state,
                projectAssignmentList: action.payload.list,
            };
        default:
            return state;
    }
};

export default ProductionGroupingReducer;
